import { useSearchParams } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { DiagnosticsPage } from '../diagnostics/DiagnosticsPage'
import { ErrorsPage } from './ErrorsPage'
import { AiServerIncidentsPage } from './AiServerIncidentsPage'
import './ErrorsHubPage.css'

type ErrorsHubTab='system'|'cameras'|'offline'|'ai'

export function ErrorsHubPage(){
 const {access}=useAuth()
 const [searchParams,setSearchParams]=useSearchParams()
 const requested=searchParams.get('tab') as ErrorsHubTab|null
 const allowed:ErrorsHubTab[]=access.isGeneralAdministrator?['system','cameras','offline','ai']:['offline']
 const active=allowed.includes(requested as ErrorsHubTab)?requested as ErrorsHubTab:allowed[0]
 const select=(tab:ErrorsHubTab)=>setSearchParams(tab==='system'?{}:{tab})
 return <section className="errors-hub-page">
  <header className="errors-hub-hero">
   <div className="errors-hub-title"><i>!</i><div><h1>Erros do sistema</h1><p>Diagnósticos técnicos, falhas de câmeras e indisponibilidades.</p></div></div>
   <nav className="errors-hub-tabs" style={{gridTemplateColumns:`repeat(${allowed.length},minmax(0,1fr))`}} aria-label="Categorias de erros">
    {access.isGeneralAdministrator&&<button className={active==='system'?'active':''} aria-current={active==='system'?'page':undefined} onClick={()=>select('system')}><i>!</i><span>Erros do sistema</span></button>}
    {access.isGeneralAdministrator&&<button className={active==='cameras'?'active':''} aria-current={active==='cameras'?'page':undefined} onClick={()=>select('cameras')}><i>◉̸</i><span>Erros de câmeras</span></button>}
    <button className={active==='offline'?'active':''} aria-current={active==='offline'?'page':undefined} onClick={()=>select('offline')}><i>⊘</i><span>Online / Offline</span></button>
    {access.isGeneralAdministrator&&<button className={active==='ai'?'active':''} aria-current={active==='ai'?'page':undefined} onClick={()=>select('ai')}><i aria-hidden="true">▤</i><span>Servidor IA</span></button>}
   </nav>
  </header>
  <div className="errors-hub-content">
   {active==='system'&&<ErrorsPage embedded/>}
   {active==='cameras'&&<DiagnosticsPage initialTab="errors" embedded/>}
   {active==='offline'&&<DiagnosticsPage initialTab="offline" embedded/>}
   {active==='ai'&&<AiServerIncidentsPage/>}
  </div>
 </section>
}
